// extracted by mini-css-extract-plugin
export var isReverse = "Social-module--isReverse--dc351";
export var isVertical = "Social-module--isVertical--d8ed9";
export var item = "Social-module--item--c1865";
export var link = "Social-module--link--72980";
export var socialLinks = "Social-module--socialLinks--3a54c";